import combineActionHandlers from "@web-monorepo/infra/combineActionHandlers";
import createAction from "@web-monorepo/infra/createAction";
import createActionHandler from "@web-monorepo/infra/createActionHandler";
import { PodInstallFunction } from "@web-monorepo/shared/podInfra";

const STATE_KEY = "variant";

const initialState = "off";

export type VariantStateSlice = {
  [STATE_KEY]: string | string[];
};

// Actions
const SET_VARIANT = createAction(`${STATE_KEY}/setVariant`);

// Action Creators
export function setVariant(variant: string | string[]) {
  return {
    type: SET_VARIANT,
    payload: {
      variant,
    },
  };
}

// Selectors
export const selectVariant = (state: { [STATE_KEY]: string | string[] }) => {
  return state?.[STATE_KEY];
};

// Final Reducer
const setVariantHandler = createActionHandler(SET_VARIANT, ({ variant }: { variant: string }) => {
  return variant;
});

// Final reducer
const finalReducer = combineActionHandlers(initialState, [setVariantHandler]);

const install: PodInstallFunction = (installReducer) => {
  installReducer(STATE_KEY, finalReducer);
};

export default install;
